var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpcoming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78 78",
    width: 78,
    height: 78,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-group100-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.21 7.29c1.53 0 3.05 0.3 4.47 0.89 1.41 0.59 2.7 1.45 3.79 2.53 1.08 1.09 1.94 2.37 2.53 3.79 0.59 1.42 0.89 2.94 0.89 4.47v23.37q0 0.77-0.3 1.49-0.3 0.71-0.84 1.26-0.55 0.55-1.26 0.85-0.72 0.29-1.5 0.29h-23.36c-2.05 0-4.07 0.41-5.96 1.19-1.89 0.78-3.61 1.93-5.06 3.38-1.44 1.44-2.59 3.16-3.37 5.05-0.79 1.89-1.19 3.92-1.19 5.96v11.69q0 0.77-0.3 1.49-0.29 0.71-0.84 1.26-0.55 0.55-1.26 0.84-0.72 0.3-1.49 0.3h-19.48c-1.53 0-3.05-0.3-4.47-0.89-1.42-0.59-2.7-1.45-3.79-2.53-1.08-1.09-1.94-2.38-2.53-3.79-0.59-1.42-0.89-2.94-0.89-4.47v-46.74c0-1.53 0.3-3.05 0.89-4.47 0.59-1.42 1.45-2.7 2.53-3.79 1.09-1.08 2.37-1.94 3.79-2.53 1.42-0.59 2.94-0.89 4.47-0.89z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #8725d1 } \r\n\t\t.s1 { fill: #dcbfff } \r\n\t\t.s2 { fill: #e0c74b } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    fillRule: "evenodd",
    className: "s0",
    d: "m66.2 7.3c1.5 0 3.1 0.3 4.5 0.9 1.4 0.6 2.7 1.4 3.8 2.5 1.1 1.1 1.9 2.4 2.5 3.8 0.6 1.4 0.9 2.9 0.9 4.5v23.3q0 0.8-0.3 1.5-0.3 0.7-0.9 1.3-0.5 0.5-1.2 0.8-0.7 0.3-1.5 0.3h-23.4c-2 0-4 0.4-5.9 1.2-1.9 0.8-3.6 2-5.1 3.4-1.4 1.4-2.6 3.2-3.4 5.1-0.7 1.8-1.2 3.9-1.2 5.9v11.7q0 0.8-0.2 1.5-0.3 0.7-0.9 1.3-0.5 0.5-1.3 0.8-0.7 0.3-1.4 0.3h-19.5c-1.6 0-3.1-0.3-4.5-0.9-1.4-0.6-2.7-1.4-3.8-2.5-1.1-1.1-1.9-2.4-2.5-3.8-0.6-1.4-0.9-3-0.9-4.5v-46.7c0-1.6 0.3-3.1 0.9-4.5 0.6-1.4 1.4-2.7 2.5-3.8 1.1-1.1 2.4-1.9 3.8-2.5 1.4-0.6 2.9-0.9 4.5-0.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Mask_Group_4",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    className: "s1",
    cx: 18.5,
    cy: 26.1,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    className: "s1",
    cx: 38.5,
    cy: 26.1,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    className: "s1",
    cx: 58.6,
    cy: 26.1,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    className: "s1",
    cx: 18.5,
    cy: 43.3,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    className: "s1",
    cx: 38.5,
    cy: 43.3,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    className: "s1",
    cx: 58.6,
    cy: 43.3,
    r: 4.3
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    className: "s2",
    d: "m44 60.7c-0.7-0.8-1.2-1.7-1.2-2.8 0-1 0.5-2 1.2-2.7 0.7-0.8 1.7-1.2 2.7-1.2 1.1 0 2.1 0.4 2.8 1.2l7.8 7.8q0.5 0.5 0.8 1.2 0.3 0.7 0.3 1.5 0 0.8-0.3 1.5-0.3 0.7-0.8 1.3l-7.8 7.7c-0.7 0.8-1.7 1.2-2.8 1.2-1 0-2-0.4-2.7-1.2-0.7-0.7-1.2-1.7-1.2-2.7 0-1 0.5-2 1.2-2.8l5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    className: "s2",
    d: "m63.5 60.7c-0.8-0.8-1.2-1.7-1.2-2.8 0-1 0.4-2 1.2-2.7 0.7-0.8 1.7-1.2 2.7-1.2 1 0 2 0.4 2.8 1.2l7.7 7.8q0.6 0.5 0.9 1.2 0.3 0.7 0.3 1.5 0 0.8-0.3 1.5-0.3 0.7-0.9 1.3l-7.7 7.7c-0.8 0.8-1.8 1.2-2.8 1.2-1 0-2-0.4-2.7-1.2-0.8-0.7-1.2-1.7-1.2-2.7 0-1 0.4-2 1.2-2.8l5-5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    className: "s1",
    d: "m23.5 3.1v6.1c0 1.7-1.8 3.1-4 3.1-2.3 0-4.1-1.4-4.1-3.1v-6.1c0-1.7 1.8-3.1 4.1-3.1 2.2 0 4 1.4 4 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530-2",
    className: "s1",
    d: "m62.6 3.1v6.1c0 1.7-1.9 3.1-4.1 3.1-2.2 0-4.1-1.4-4.1-3.1v-6.1c0-1.7 1.9-3.1 4.1-3.1 2.2 0 4.1 1.4 4.1 3.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpcoming);
export default __webpack_public_path__ + "static/media/icon-upcoming.6c072cdb5b87476297de40a5eaba1fd2.svg";
export { ForwardRef as ReactComponent };